import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'tickets'

export const Tickets: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
